import { createSlice } from '@reduxjs/toolkit';
import {decrypt} from '../../crypto'

const initialState = {
  id: null,
  rememberMe: false, // To track if the user chose "Remember Me"
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { id, rememberMe, isAdmin } = action.payload;
      state.id = id;
      state.admin = decrypt(isAdmin);
      state.rememberMe = rememberMe;

      // Save to localStorage only if "Remember Me" is checked
      if (rememberMe) {
        localStorage.setItem('loginId', id);
      }
    },
    clearUser: (state) => {
      state.id = null;
      state.rememberMe = false;
      localStorage.removeItem('loginId'); // Clear stored data on logout
    },
    loadUserFromStorage: (state) => {
      const storedId = localStorage.getItem('loginId');
      const isAdmin = localStorage.getItem('i_a');

      if (storedId) {
        state.id = storedId;
        state.admin = decrypt(isAdmin);
        state.rememberMe = true; // Assume "Remember Me" was checked if data exists
      }
    },
  },
});

export const { setUser, clearUser, loadUserFromStorage } = userSlice.actions;
export default userSlice.reducer;
